var ProductAccessoriesComponent = Vue.component('product-accessories', {
    props: ['productId'],
    data: function () {
        return {
            accessories: [],
            loaded: false
        };
    },
    created: function() {
        this.fetch('post', 'rshop-api/products/accessories', { product_id: this.productId }, function (response) {
            this.accessories = response.result.accessories;
            this.loaded = true;

            rEvent.dispatch('ProductAccessories.loaded');
        }.bind(this));
    },
    computed: {
        empty: function() {
            return this.accessories.length == 0;
        }
    }
});